var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    attrs: { type: "text", autocomplete: "off", disabled: _vm.disabled },
    domProps: { value: _vm.value },
    on: { input: _vm.update }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }